import { useEffect, useState } from "react";
import { loadOADoctors, type OADoctor } from "./oaProvidersV4";

type ProviderResult = {
  token?: string;
  division?: number;
  doctors: OADoctor[];
  loading: boolean;
  error: string;
};

/** Hide the previous OA's options synchronously and discard late responses. */
export const useOAProvidersV4 = (apiToken: string | undefined, division: number | string | undefined) => {
  const divisionId = Number(division);
  const [result, setResult] = useState<ProviderResult>({ doctors: [], loading: true, error: "" });
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    let current = true;
    setResult({ token: apiToken, division: divisionId, doctors: [], loading: true, error: "" });
    if (!apiToken || !divisionId) {
      setResult({ token: apiToken, division: divisionId, doctors: [], loading: false, error: "" });
      return;
    }
    loadOADoctors(apiToken, divisionId).then(
      (doctors) => {
        if (current) setResult({ token: apiToken, division: divisionId, doctors, loading: false, error: "" });
      },
      (error) => {
        if (current) setResult({ token: apiToken, division: divisionId, doctors: [], loading: false, error: error.message });
      },
    );
    return () => { current = false; };
  }, [apiToken, divisionId, attempt]);
  const matches = result.token === apiToken && Object.is(result.division, divisionId);
  return {
    doctors: matches ? result.doctors : [],
    loading: !matches || result.loading,
    error: matches ? result.error : "",
    reload: () => setAttempt((value) => value + 1),
  };
};
